<template>
<div class="home" :style="{background: bg_accent}">
  <div class="page intro center" @click="pabajo('.grid')">
    <h1 class="tit">
      <span v-html="textos[idioma].soyroberto + años_diseño + textos[idioma].soyroberto1"></span><br>
      <!-- <em class="tit serif love">{{loves[idioma][love_count]}}</em> -->
      <em class="tit serif love">
        <span class="love_text" :class="{selected: love_selecting}" v-html="love_typed" /><span class="cursor" v-show="!love_selecting">|</span>
      </em>
    </h1>
    <img v-if="scroll_arrow" class="scroll_arrow" src="../../public/images/cursor_arrowDown.svg" />
  </div>
  <div class="page">
    <section class="grid" ref="bg_accent">
      <!-- <p class="bigparr yo">
        Estoy más cómodo cuando trabajo mano a mano con producto
        Me encanta colaborar directamente en
        Mi habilidad para ayudar a simplificar y entender los objetivos de negocio, y aplicarlos al diseño
        Mis combo favorito es colaborar estrechamente con negocio desde el principio, para
      </p> -->
      <div class="sticky">
        <p class="bigparr yo" v-html="textos[idioma].eltipico" />
      </div>
      <div class="sticky">
        <p class="bigparr yo" v-html="textos[idioma].temporada" />
      </div>
      <div class="sticky">
        <p class="bigparr yo" v-html="textos[idioma].spoilers" />
      </div>
      <div class="carousel-container">
        <div class="carousel-textos" ref="carouselTextos">
          <div v-for="(item, index) in carousel_proyectos[idioma]" :key="'proy-'+index+'-a'" :style="{ top: item.top, transform: 'rotate(' + item.rotate + ')' }">
            <p class="medparr"><span v-html="item.txt"></span><span class="small">{{ item.contxt }}</span></p>
          </div>
          <div v-for="(item, index1) in carousel_proyectos[idioma]" :key="'proy-'+index1+'-b'" :style="{ top: item.top, transform: 'rotate(' + item.rotate + ')' }">
            <p class="medparr"><span v-html="item.txt"></span><span class="small">{{ item.contxt }}</span></p>
          </div>
        </div>
        <div class="carousel-images" ref="carouselImages">
          <img v-for="(img, indes) in carousel_img" :key="'img-'+indes+'-1'" :src="img.url" :style="{ top: img.top, transform: 'rotate(' + img.rotate + ')' }">
          <img v-for="(img, indess) in carousel_img" :key="'img-'+indess+'-2'" :src="img.url" :style="{ top: img.top, transform: 'rotate(' + img.rotate + ')' }">
        </div>
        <div class="lines">
          <span class="line"></span>
          <span class="line"></span>
          <span class="line"></span>
          <span class="line"></span>
        </div>
      </div>
      <p class="medparr yo">
        <!-- Tengo otros proyectos más antiguos pero con 'cases' más elaborados, por si quieres <a class="bold" @click="$router.push('Otros');">cotillear</a>.  -->
        {{textos[idioma].cotilleo}} <a class="bold" @click="$router.push('Otros');">{{textos[idioma].cotilleo1}}</a>. 
      </p>
    </section>
    <section>
    </section>
    <section>
      <futer />
    </section>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
// import porfolio from "@/components/porfolio.vue";
import futer from "@/components/futer.vue";

export default {
  name: 'Home',
  components: {futer},
  props: {
    currentScrollPosition: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState(['idioma'])
  },
  data() {
    return {
      active_proy: false,
      años_diseño: 6,
      scroll_arrow: false,
      bg_accent: '',
      // love: '',
      love_count: 0,
      love_typed: '',
      love_selecting: false,
      loves: {
        es: [
          "contruyendo productos digitales con sentido y <b>mimo</b>",
          "<b>colaborando</b> con managers, diseñadores, desarrolladores, researchers, etc.",
          "haciendo muuuchas <b>preguntas</b> y buceando entre specs y bdrs",
          "sumergiéndome <b>hasta el fondo</b> en cada nuevo proyecto",
          "<b>proponiendo</b> alternativas que pueden conseguir mejor nuestro objetivo",
          "en reuniones de alineamiento",
          "<b>aprendiendo</b> de cada proyecto nuevo"
        ],
        en: [
          "building digital products with sense and <b>care</b>",
          "<b>collaborating</b> with managers, designers, devs, researchers, etc.",
          "making looots of <b>questions</b> and swimming into specs and bdrs",
          "<b>proposing</b> alternatives that can better achieve our goal",
          "diving <b>deep down</b> into every project",
          "<b>learning</b>, always learning",
          "and of course, in aligment meetings..."
        ]
      },
      last_scroll_pos: 0,
      last_scroll_time: null,
      scroll_speed_reset: null,
      carousel_widths: { textos: 0, images: 0 },
      carousel_offset: { textos: 0, images: 0 },
      speed_multiplier: 1,
      target_multiplier: 1,
      carousel_raf: null,
      last_frame_time: null,
      carousel_proyectos: {
        es: [
          {txt: "el del <b>funnel de contratación</b> de préstamos con simuladores",
            contxt: "temp. 2024 - BBVA"
          },
          {txt: "el de la <b>nueva funcionalidad</b> de compra-venta de activos digitales",
            contxt: "temp. 2022 - BBVA"
          },
          {txt: "el del <b>recomendador</b> de productos financieros",
            contxt: "temp. 2024 - BBVA"
          },
          {txt: "el de la <b>reserva</b> de automóviles",
            contxt: "temp. 2023 - BBVA"
          },
          {txt: "el del <b>replanteamiento de la app bancaria</b> para un sector concreto.",
            contxt: "temp. 2024 - BBVA"
          },
          {txt: "el del <b>acompañamiento y contratación</b> de agentes digitalizadores",
            contxt: "temp. 2021 - Vodafone"
          },
          {txt: "el de la <b>herramienta interna</b> de info y recursos globales de productos",
            contxt: "temp. 2025 - Getnet"
          },
          {txt: "el del <b>rediseño del portal</b> de gestión de ventas",
            contxt: "temp. 2025 - Getnet"
          }
        ],
        en: [
          {
            txt: "The one about the loan application funnel with simulators",
            contxt: "Season 2024 - BBVA"
          },
          {
            txt: "The one about the new buy/sell feature for digital assets",
            contxt: "Season 2022 - BBVA"
          },
          {
            txt: "The one about the financial product recommender",
            contxt: "Season 2024 - BBVA"
          },
          {
            txt: "The one about the car booking experience",
            contxt: "Season 2023 - BBVA"
          },
          {
            txt: "The one about rethinking the entire banking app for a specific sector",
            contxt: "Season 2024 - BBVA"
          },
          {
            txt: "The one about onboarding and contracting digital transformation agents",
            contxt: "Season 2021 - Vodafone"
          },
          {
            txt: "The one about the internal global product info and resources tool",
            contxt: "Season 2025 - Getnet"
          },
          {
            txt: "The one about the sales management portal redesign",
            contxt: "Season 2025 - Getnet"
          }
        ]
      },
      carousel_img: [
        {url: "images/Mockup mobile.png"},
        {url: "images/Mockup mobile-5.png"},
        {url: "images/Mockup mobile-1.png"},
        {url: "images/Mockup mobile-4.png"},
        {url: "images/Mockup mobile-2.png"},
        {url: "images/Mockup mobile-3.png"},
        {url: "images/Mockup mobile-6.png"},
        {url: "images/Mockup mobile-7.png"}
      ],
      textos: {
        es: {
          soyroberto: 'aquí Rober Mesejo<br><br>y entre otras cosas random, llevo <b>más de ',
          // soyroberto: 'Soy Roberto Mesejo<br>llevo <b>ayudando a crear productos digitales con sentido y mimo desde hace más de ',
          soyroberto1: ' años</b>',
          eltipico: 'Soy el típico que se zambulle 💦🤿 hasta el fondo para entender cada detalle relacionado con los productos y explora todo tipo de profundidades (comencé como ux-front y ahora trabajo más como product-strategy designer).',
          temporada: '<i>En la última temporada...</i> se me ha visto metido en grandes equipos de diseño, seguramente trabajando muy de la mano con algún PO, adaptando propuestas a nuevas necesidades...',
          // temporada: '<i>En la última temporada...</i> se me ha visto metido en grandes equipos de diseño, seguramente reunido con algún PO, sonsacándole info sobre objetivos del proyecto o adaptando propuestas a nuevas necesidades.<br><br>O puede que hablando con desarrollo, content, research, analítica, heads de diseño...',
          spoilers: '...pero no te quiero hacer spoilers. Estas serían las <b>portadas</b> de algunos de los últimos capítulos como product designer:',
          cotilleo: "Puedes ver algún capítuliño completo de temporadas anteriores, si te apetece ",
          cotilleo1: "cotillear",
          // mefascina: 'Me fascina el proceso creativo.',
          // intentoconocer: '<b>Intento conocer e involucrarme en todas las etapas de creación de un producto</b> (entender mejor cómo funcionan y se conectan las piezas me parece muy útil para intentar resolver el puzzle)',
          // asiheorganizado: 'y por eso he organizado mis proyectos según la fase en la que he intervenido:',
          // cadaproyectotiene: 'Para dar más contexto, cada proyecto tiene tambien etiquetas según para quién lo he realizado (estudios, empresas, como freelance o emprendedor) y el producto final (plataformas, webs y apps)'
        }, 
        en: {
          soyroberto: "Rober Mesejo here, <br><br> and beside many random stuff, I've been working for <b>more than ",
          soyroberto1: " years</b>",
          eltipico: "I'm the type who dives in  💦🤿  deep to understand everything about the products and explores all kinds of dephs (I started as ux-front and now I lean more towards product design strategy).",
          temporada:"On the last season...I've been spotted working within large design teams, most likely working close to some PO, adapting proposals to new needs...",
          spoilers: "...but I won't give you any spoilers, these would be the <b>covers</b> of some of the latest episodes as product designer:",
          cotilleo: "You can sneak peek an older full detailed episode, if you feel like ",
          cotilleo1: "snooping around", 
          // mefascina: 'I am fascinated by the creative process.',
          // intentoconocer: '<b>I like getting involved in all of the phases for creating a product</b> so I can have a holistic view of the project.',
          // asiheorganizado: "That's why I've arranged the projects by the phase in which I have intervened:",
          // cadaproyectotiene: 'Each project also has other labels for context: who I made it for (companies, studies, as freelance, or as entrepeneur) and the final product (platforms, webs and apps)'
        }
      },
    }
  },
  watch: {
    currentScrollPosition() {
      if (!this.$refs.bg_accent) return;
      if (this.currentScrollPosition > this.$refs.bg_accent.offsetTop) {
        if (!this.bg_accent) this.bg_accent = 'linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 16.24%), #FBF6F1';
      } else {
        this.bg_accent = '';
      }
      this.adjustCarouselSpeed();
    }
  },
  mounted: function() {
    setTimeout(() => {document.querySelector(".page.intro").style.opacity = 1;}, 50)
    
    this.typeLoop();

    if (window.innerWidth < 600) setTimeout(() => this.scroll_arrow = true, 4000);
    
    this.años_diseño = (new Date().getFullYear() - 2015) || 6;
        
    this.carousel_proyectos.es.forEach((proy) => {
      proy.top = `${Math.random()*5}em`;
      proy.rotate = `${Math.random()*2 - 1}deg`;
    }) 
    this.carousel_img.forEach((img) => {
      img.top = `${Math.random()*5}em`;
      img.rotate = `${Math.random()*10 - 5}deg`;
    });

    // this.$nextTick(() => {
    //   this.carousel_widths.textos = this.$refs.carouselTextos ? this.$refs.carouselTextos.scrollWidth / 2 : 0;
    //   this.carousel_widths.images = this.$refs.carouselImages ? this.$refs.carouselImages.scrollWidth / 2 : 0;
    //   this.startCarouselLoop();
    // });
    this.$nextTick(() => {
      const imgEls = this.$refs.carouselImages ? this.$refs.carouselImages.querySelectorAll('img') : [];
      const loadPromises = Array.from(imgEls).map((img) => {
        if (img.complete) return Promise.resolve(); // ya cargada (p.ej. desde caché)
        return new Promise((resolve) => {
          img.addEventListener('load', resolve, { once: true });
          img.addEventListener('error', resolve, { once: true }); // por si alguna falla, no bloquear el resto
        });
      });

      Promise.all(loadPromises).then(() => {
        this.carousel_widths.textos = this.$refs.carouselTextos ? this.$refs.carouselTextos.scrollWidth / 2 : 0;
        this.carousel_widths.images = this.$refs.carouselImages ? this.$refs.carouselImages.scrollWidth / 2 : 0;
        this.startCarouselLoop();
      });
    });
  },
  beforeDestroy() {
    clearTimeout(this._loveTimeout);
    clearTimeout(this.scroll_speed_reset);
    cancelAnimationFrame(this.carousel_raf);
  },
  methods: {
    pabajo(destino) {
      let destino_dom = document.querySelector(destino);
      if ((this.currentScrollPosition < (destino_dom.offsetTop + 500)) || (this.currentScrollPosition < (destino_dom.offsetParent.offsetTop + 500))) {
        destino_dom.scrollIntoView({ behavior: 'smooth' });
      } 
    },
    typeLoop() {
      const word = this.loves[this.idioma][this.love_count];
      let i = 0;

      const typeChar = () => {
        this.love_typed = word.slice(0, i);
        if (i < word.length) {
          i++;
          this._loveTimeout = setTimeout(typeChar, 30);
        } else {
          this._loveTimeout = setTimeout(selectAll, 2000); // pausa con la frase completa
        }
      };

      const selectAll = () => {
        this.love_selecting = true;
        this._loveTimeout = setTimeout(deleteSelected, 350); // tiempo que se ve "seleccionado"
      };

      const deleteSelected = () => {
        this.love_typed = '';
        this.love_selecting = false;
        this.love_count = this.love_count < (this.loves[this.idioma].length - 1) ? this.love_count + 1 : 0;
        this._loveTimeout = setTimeout(this.typeLoop, 400); // pausa antes de la siguiente frase
      };

      typeChar();
    },
    startCarouselLoop() {
      const baseSpeedTextos = this.carousel_widths.textos / (40 * 1000); // px/ms — equivalente a tus 60s originales
      const baseSpeedImages = this.carousel_widths.images / (20 * 1000);

      const step = (now) => {
        if (!this.last_frame_time) this.last_frame_time = now;
        const dt = now - this.last_frame_time;
        this.last_frame_time = now;

        // suaviza el cambio entre velocidad actual y la velocidad objetivo (evita frenazos/acelerones brutos)
        this.speed_multiplier += (this.target_multiplier - this.speed_multiplier) * 0.2;

        if (this.carousel_widths.textos) {
          this.carousel_offset.textos = (this.carousel_offset.textos + baseSpeedTextos * this.speed_multiplier * dt) % this.carousel_widths.textos;
          if (this.$refs.carouselTextos) this.$refs.carouselTextos.style.transform = `translateX(-${this.carousel_offset.textos}px)`;
        }
        if (this.carousel_widths.images) {
          this.carousel_offset.images = (this.carousel_offset.images + baseSpeedImages * this.speed_multiplier * dt) % this.carousel_widths.images;
          if (this.$refs.carouselImages) this.$refs.carouselImages.style.transform = `translateX(-${this.carousel_offset.images}px)`;
        }

        this.carousel_raf = requestAnimationFrame(step);
      };

      this.carousel_raf = requestAnimationFrame(step);
    },
    adjustCarouselSpeed() {
      const now = Date.now();

      if (this.last_scroll_time) {
        const deltaPos = Math.abs(this.currentScrollPosition - this.last_scroll_pos);
        const deltaTime = Math.max(now - this.last_scroll_time, 16);
        const speed = deltaPos / deltaTime; // px/ms
        const maxSpeed = 3;
        const clampedSpeed = Math.min(speed, maxSpeed);

        const maxMultiplier = 20; // tope: 4x más rápido que la velocidad normal
        this.target_multiplier = 1 + (clampedSpeed / maxSpeed) * (maxMultiplier - 1);

        // console.log('[carousel-debug]', { currentScrollPosition: this.currentScrollPosition, deltaPos, deltaTime, speed, target_multiplier: this.target_multiplier }); // línea nueva, temporal


        clearTimeout(this.scroll_speed_reset);
        this.scroll_speed_reset = setTimeout(() => {
          this.target_multiplier = 1;
        }, 200);
      }

      this.last_scroll_pos = this.currentScrollPosition;
      this.last_scroll_time = now;
    },
    
  }
}
</script>
<style scoped lang="scss">
.home {
  transition: background 1s ease-in;
  .page.intro {
    position: relative;
    margin-bottom: -20vh;
    cursor: url("../../public/images/cursor_arrowDown.svg"), pointer;
    opacity: .2;
    transition: opacity 1s ease-in;
    .tit {
      text-align: center;
      max-width: 100%;
      // overflow-x: hidden;
      font-weight: normal;
    }
    .love {
      display: inline-block;
      height: 3em;
      // margin-top: .3em;
      position: relative;
      color: var(--color_accent);
      // font-weight: bold;
      font-size: 1.2em;
      line-height: 1.1em;
      width: 150%;
      margin: .3em -50%;
      // animation: 7s infinite ease-out slidein;
      .love_text {
        transition: background-color .1s ease-out;
        border-radius: 2px;
        &.selected {
          background-color: var(--color_accent);
          color: var(--color_accent_bg);
        }
      }
      .cursor {
        display: inline-block;
        animation: blink 1s step-end infinite;
      }
    }
    .scroll_arrow {
      position: absolute;
      top: 94vh;
      left: 50%;
      height: 4vh;
      transform: translateX(-50%);
    }
  }
  section.grid {
    position: relative;
    padding: 30vh 0;
    .sticky {
      height: 80vh;
      margin-bottom: 4em;
      .yo.bigparr {
        position: sticky;
        top:40%;
      }
    }
    .carousel-container {
      position: relative;
      padding: 4em;
      margin-bottom: 4rem;
      .lines {
        position: absolute;
        top: 0;
        left: -15vw;
        padding-top: 4em;
        width: 120vw;
        height: 100%;
        display: flex;
        gap: 1em;
        z-index: -1;
        flex-direction: column;
        justify-content: space-around;
        .line {
          display: block;
          width: 100%;
          height: 100%;
          border-top: 1px solid var(--color_accent);
          border-bottom: 1px solid var(--color_accent);
          opacity: .1;
        }
      }
      .carousel-images {
        position: relative;
        left: 0;
        width: max-content;
        height: 100%;
        display: flex;
        align-items: center;
        // gap: 10em;
        // animation: carrousel-reverse 60s linear infinite;
        opacity: 0.5;
        img {
          position: relative;
          margin-right: 10em;
          transition: top .25s ease-out, rotate .25s ease-out;
          height: 100%;
          object-fit: cover;
          border-radius: 4px;
          height: 25em;
          filter: drop-shadow(1em .5em .7em rgba(0, 0, 0, 0.25));
          max-width: unset;
        }
      }
    
      .carousel-textos {
        position: absolute;
        left: 0;
        width: max-content;
        height: 100%;
        z-index: 1;
        top: 0;
        display: flex;
        align-items: center;
        // gap: 8em;
        // animation: carrousel 60s linear infinite;
        &>div {
          // display: flex;
          position: relative; 
          margin-right: 8em;
          padding: 1em .8em;
          border: 1px solid var(--color_accent);
          background-color: rgba(255,255,255,.25);
          backdrop-filter: blur(4px);
          p {
            width: max-content;
            max-width: 28ch;
            text-align: center;
            transition: opacity 0.3s ease-out;
            color: var(--color_accent);
            margin-bottom: 0;
            font-style: italic;
            .small {
              display: block;
              font-style: normal;
              margin-top: .5em;
              font-size: .8em;
              text-align: right;
            }
          }
        }
      }
    }
    a {text-decoration: underline; cursor: pointer;}
  }
  @keyframes blink {
    50% { opacity: 0; }
  }
  // @keyframes carrousel {
  //   0% { transform: translateX(0%); }
  //   100% { transform: translateX(-50%); }
  // }
  // @keyframes carrousel-reverse {
  //   0% { transform: translateX(0%); }
  //   100% { transform: translateX(-50%); }
  // }

}
</style>